/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindBusinessPartnerRepositoryCompaniesQueryResponse,
  FindBusinessPartnerRepositoryCompaniesQueryParams,
} from "../types/FindBusinessPartnerRepositoryCompanies.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findBusinessPartnerRepositoryCompaniesQueryKey = (
  params: FindBusinessPartnerRepositoryCompaniesQueryParams
) =>
  [
    { url: "/v1/contacts/bp-autocomplete/company" },
    ...(params ? [params] : []),
  ] as const

export type FindBusinessPartnerRepositoryCompaniesQueryKey = ReturnType<
  typeof findBusinessPartnerRepositoryCompaniesQueryKey
>

/**
 * @summary Search business partner repository organizations
 * {@link /v1/contacts/bp-autocomplete/company}
 */
export async function findBusinessPartnerRepositoryCompanies(
  params: FindBusinessPartnerRepositoryCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindBusinessPartnerRepositoryCompaniesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/contacts/bp-autocomplete/company`,
    params,
    ...requestConfig,
  })
  return res
}

export function findBusinessPartnerRepositoryCompaniesQueryOptions(
  params: FindBusinessPartnerRepositoryCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findBusinessPartnerRepositoryCompaniesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindBusinessPartnerRepositoryCompaniesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindBusinessPartnerRepositoryCompaniesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findBusinessPartnerRepositoryCompanies(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Search business partner repository organizations
 * {@link /v1/contacts/bp-autocomplete/company}
 */
export function useFindBusinessPartnerRepositoryCompanies<
  TData = ResponseConfig<FindBusinessPartnerRepositoryCompaniesQueryResponse>,
  TQueryData =
    ResponseConfig<FindBusinessPartnerRepositoryCompaniesQueryResponse>,
  TQueryKey extends QueryKey = FindBusinessPartnerRepositoryCompaniesQueryKey,
>(
  params: FindBusinessPartnerRepositoryCompaniesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindBusinessPartnerRepositoryCompaniesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findBusinessPartnerRepositoryCompaniesQueryKey(params)

  const query = useQuery(
    {
      ...findBusinessPartnerRepositoryCompaniesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
